window.mobilemainnavigation = false;

function init() {

  const smallScreen                       = (window.innerWidth <= 767) ? true : false;
  const documentHeight                    = document.documentElement.clientHeight;
  const headerElement                     = document.querySelector('.header');
  const mobilePropertySearchElement       = document.querySelector('.mobilepropertysearch');
  const mobilePropertyFilterElement       = document.querySelector('.mobilepropertyfilter');
  const mainElement                       = document.querySelector('.main');
  const mobileMainnavgationElement        = document.querySelector('.mobilemainnavigation');
  const mobileMainnavgationOpenClassName  = 'mobilemainnavigation--open';
  const mobileMainnavgationInnerElement   = document.querySelector('.mobilemainnavigation__containerinner');
  const mobileMainnavigationLink          = document.querySelector('.header__mobilemainnavigationlink');
  const mobileMainnavigationCloseLink     = document.querySelector('.mobilemainnavigation__closelink');
  const mobileMainnavigationLevel1Links   = Array.from(mobileMainnavgationElement.querySelectorAll('.mainnavigation__grouptitle'));
  const iPhone                            = (/iPhone/i.test(navigator.userAgent)) ? true : false;
  const noScrollClassName                 = (iPhone) ? 'noscrollfixed' : 'noscroll';


  if (!window.mobilemainnavigation && smallScreen) {
    window.mobilemainnavigation = true;

    // add event listener to mobile mainnavi link
    if (mobileMainnavigationLink) {
      mobileMainnavigationLink.addEventListener('click', (e) => {
        e.preventDefault();
        openMobileMainnavigation();
      });
    }

    // add event listener to mobile mainnavi close link
    if (mobileMainnavigationCloseLink && mobileMainnavgationInnerElement) {
      mobileMainnavigationCloseLink.addEventListener('click', (e) => {
        e.preventDefault();
        closeMobileMainnavigation();
      });
    }

    // add event listener to mainlevel items & dropdown icon
    if (mobileMainnavigationLevel1Links) {
      mobileMainnavigationLevel1Links.map((link) => {

        //mainlevel - parent link
        link.addEventListener('click', function(e) {
          let level2 = this.closest('.mainnavigation__group');

          //only prevent link href when sub is not open
          if (!level2.classList.contains('mainnavigation__group--open')) {
            e.preventDefault();
            level2.classList.toggle('mainnavigation__group--open');
          }
        });

        //mainlevel - dropdown
        let dd = link.nextElementSibling;
        if (dd) {
          dd.addEventListener('click', function(e) {
            let level2 = this.closest('.mainnavigation__group');
            level2.classList.toggle('mainnavigation__group--open');
          });
        }
      });
    }

    function openMobileMainnavigation() {
      if (mobileMainnavgationElement && headerElement && mainElement) {
        document.body.classList.add(noScrollClassName);
        mobileMainnavgationElement.classList.add(mobileMainnavgationOpenClassName);
        headerElement.classList.add('header--hide');
        if (mobilePropertySearchElement) {
          mobilePropertySearchElement.classList.add('mobilepropertysearch--hide');
        }
        if (mobilePropertyFilterElement) {
          mobilePropertyFilterElement.classList.add('mobilepropertyfilter--hide');
        }
        mainElement.style.marginTop = '0px';

        // check if clicked inside mainnavi element
        if (mobileMainnavigationLink && mobileMainnavgationInnerElement) {
          window.docClickCloseMainnavigation = function(e) {
            let isClickInside = mobileMainnavgationInnerElement.contains(e.target) || mobileMainnavigationLink.contains(e.target);
            if (!isClickInside) {
              closeMobileMainnavigation();
            }
          }
        }
        // add event listener to document to detect an outside click
        if (window.docClickCloseMainnavigation) {
          document.addEventListener('click', window.docClickCloseMainnavigation);
        }
      }
    }

    function closeMobileMainnavigation() {
      if (mobileMainnavgationElement && headerElement && mainElement) {
        document.body.classList.remove(noScrollClassName);
        mobileMainnavgationElement.classList.remove(mobileMainnavgationOpenClassName);
        setTimeout(() => {
          headerElement.classList.remove('header--hide');
          if (mobilePropertySearchElement) {
            mobilePropertySearchElement.classList.remove('mobilepropertysearch--hide');
          }
          if (mobilePropertyFilterElement) {
            mobilePropertyFilterElement.classList.remove('mobilepropertyfilter--hide');
          }
          if (mobilePropertySearchElement && mobilePropertyFilterElement) {
            mainElement.style.marginTop = headerElement.offsetHeight + 'px';
          } else {
            mainElement.style.marginTop = headerElement.offsetHeight + 'px';
          }
        }, 400);

        // remove event listener from document to detect outside click
        if (window.docClickCloseMainnavigation) {
          document.removeEventListener('click', window.docClickCloseMainnavigation);
          delete window.docClickCloseMainnavigation;
        }
      }
    }

  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Mobilemainnavigation.js